import { render } from "./ContentBlock.vue?vue&type=template&id=7d4fe4b8"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"

import "./ContentBlock.vue?vue&type=style&index=0&id=7d4fe4b8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__